import React from 'react'
import { useTranslation } from 'react-i18next'

function CustomJewelry() {
  const { t } = useTranslation()

  return (
    <section className="tc-project-style1 header">
      <div className="main-info">
        <div className="container">
          <h1 className="title marcellus">{t('customPage.title')}</h1>
          <div className="text fsz-19 color-666 mt-30 marcellus">{t('customPage.subtitle')}</div>
        </div>
      </div>
      <div className="main-img">
        <img
          src="/assets/images/gallery/portfolio/craft.jpg"
          alt=""
          className="img-cover"
          data-speed="1.25"
        />
      </div>
      <div className="challenge pb-120">
        <div className="container">
          <h3 className="sub-title fsz-45 mb-60 wow fadeInUp slow marcellus" data-wow-delay="0.2s">
            {t('customPage.craft.title')}
          </h3>
          <div
            className="text fsz-24 mb-20 fw-500 wow fadeInUp slow marcellus"
            data-wow-delay="0.2s"
          >
            {t('customPage.craft.description')}
          </div>
          <ul
            className="dots-list fsz-18 color-666 wow fadeInUp slow marcellus"
            data-wow-delay="0.2s"
          >
            <li className="d-flex my-4">
              <span className="icon me-3"> • </span> {t('customPage.craft.points.collaboration')}
            </li>
            <li className="d-flex my-4">
              <span className="icon me-3"> • </span> {t('customPage.craft.points.materials')}
            </li>
            <li className="d-flex my-4">
              <span className="icon me-3"> • </span> {t('customPage.craft.points.care')}
            </li>
          </ul>
          <div className="imgs mt-120">
            <div className="row">
              <div className="col-lg-4">
                <div
                  className="img th-350 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                  data-wow-delay="0.2s"
                >
                  <video
                    src="/assets/images/gallery/portfolio/IMG_4493.mp4"
                    poster="/assets/images/gallery/portfolio/push.png"
                    className="img-cover"
                    controls
                    muted
                    playsInline
                    preload="metadata"
                  ></video>
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className="img th-350 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                  data-wow-delay="0.4s"
                >
                  <video
                    src="/assets/images/gallery/portfolio/arf.MP4"
                    poster="/assets/images/gallery/portfolio/arf.jpg"
                    className="img-cover"
                    controls
                    muted
                    playsInline
                    preload="metadata"
                  ></video>
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className="img th-350 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                  data-wow-delay="0.6s"
                >
                  <video
                    src="/assets/images/gallery/portfolio/vid2.mp4"
                    poster="/assets/images/gallery/portfolio/shamrock2.jpeg"
                    className="img-cover"
                    controls
                    muted
                    playsInline
                    preload="metadata"
                  ></video>
                </div>
              </div>
            </div>
          </div>

          <h3
            className="sub-title fsz-45 mb-60 mt-150 wow fadeInUp slow marcellus"
            data-wow-delay="0.2s"
          >
            {t('customPage.experience.title')}
          </h3>
          <div
            className="text fsz-24 mb-20 fw-500 wow fadeInUp slow marcellus"
            data-wow-delay="0.2s"
          >
            {t('customPage.experience.description')}
          </div>
          <div className="imgs mt-120">
            <div className="row">
              <div className="col-lg-4">
                <div
                  className="img th-350 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                  data-wow-delay="0.2s"
                >
                  <img
                    src="/assets/images/gallery/portfolio/push.png"
                    alt=""
                    className="img-cover"
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className="img th-350 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                  data-wow-delay="0.4s"
                >
                  <img
                    src="/assets/images/gallery/portfolio/arf.jpg"
                    alt=""
                    className="img-cover"
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className="img th-350 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                  data-wow-delay="0.6s"
                >
                  <img
                    src="/assets/images/gallery/portfolio/shamrock2.jpeg"
                    alt=""
                    className="img-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="imgs mt-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div
                className="img th-600 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                data-wow-delay="0.4s"
              >
                <img
                  src="/assets/images/gallery/portfolio/boxes.jpeg"
                  alt=""
                  className="img-cover"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="img th-600 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                data-wow-delay="0.2s"
              >
                <img
                  src="/assets/images/gallery/portfolio/IMG_2215.jpeg"
                  alt=""
                  className="img-cover"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="img th-600 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                data-wow-delay="0.4s"
              >
                <img src="/assets/images/gallery/portfolio/bg2.jpeg" alt="" className="img-cover" />
              </div>
            </div>{' '}
            <div className="col-lg-6">
              <div
                className="img th-600 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                data-wow-delay="0.2s"
              >
                <img src="/assets/images/gallery/portfolio/bg1.jpg" alt="" className="img-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CustomJewelry
